export enum RecipientType {
  Myself = 'myself',
  SomeoneElse = 'someoneElse',
  Organization = 'organization',
}
